import {
    OpenMobileAppCloseButtonStyled,
    OpenMobileAppContentStyled,
    OpenMobileAppLogoContainerStyled,
    OpenMobileAppStyled
} from "./styled/OpenMobileAppStyled";
import { Logo } from "../../components/LogoComponent/LogoComponent";
import StoreButton from "../../components/store-button/StoreButton";
import { STORE_BUTTON_TYPES } from "../../components/store-button/store-button-constants";
import { BinIcon } from "../../components/icon/Icon";
import { useLangContext } from "../../providers/LangProvider/LangProviderContext";
import { useMemo } from "react";
import _ from "lodash";

function OpenMobileApp(props) {
    const {onClose} = props;
    const {getLangPath} = useLangContext();
    const randomOption = useMemo(() => _.random(1, 3), []);

    return <OpenMobileAppStyled>
        <OpenMobileAppCloseButtonStyled onClick={onClose}>
            <BinIcon name="IcClose"/>
        </OpenMobileAppCloseButtonStyled>
        <OpenMobileAppContentStyled>
            <OpenMobileAppLogoContainerStyled>
                <Logo isShort height="30px"/>
            </OpenMobileAppLogoContainerStyled>
            <h1 className="mt-4 mb-0 text-center">{getLangPath(`store_links.open_app.option_${randomOption}.title`)}</h1>
            <p className="f16 mt-4 mb-0 text-center">{getLangPath(`store_links.open_app.option_${randomOption}.description`)}</p>
            <StoreButton type={STORE_BUTTON_TYPES.google} className="google-button"/>
        </OpenMobileAppContentStyled>
    </OpenMobileAppStyled>
}

export default OpenMobileApp;
